import type {Translator} from '@yandex-delivery/core/i18n'
import type {Optional} from '@yandex-delivery/types'
import {applySpec, get, pipe} from '@yandex-delivery/utils'
import type {
  ContactOnPoint,
  DestinationPoint,
  PointContact,
  PointType,
  ReturnPoint,
  SourcePoint,
} from 'src/shared/types'

import {dropEmptyValues} from './drop-empty-values'
import {getPointType} from './get-point-type'

export const getContactEmail: (contact?: PointContact) => Optional<string> =
  get('email')

export const getContactPhone: (contact?: PointContact) => Optional<string> =
  get('phone')

function getDefaultName(t: Translator, pointType?: PointType) {
  return pointType === 'source'
    ? t('phoenix.cargo.create.route.sender')
    : t('phoenix.cargo.create.route.recipient')
}

function getContactName(t: Translator, point?: PointType) {
  return (contact: PointContact) => {
    const name = get('name', contact)
    return name ? name : getDefaultName(t, point)
  }
}

const fromContact: (
  t: Translator,
  pointType?: PointType,
) => (contact?: PointContact) => ContactOnPoint = (
  t: Translator,
  pointType?: PointType,
) =>
  applySpec<ContactOnPoint>({
    name: getContactName(t, pointType),
    phone: getContactPhone,
    email: getContactEmail,
  })

export const fromPointContact =
  (t: Translator) => (point: SourcePoint | DestinationPoint | ReturnPoint) => {
    const pointType = getPointType(point)
    const contact = get('contact', point)

    return pipe(contact, fromContact(t, pointType), dropEmptyValues)
  }
